<template>
  <div>
    <div class="image-container" @dblclick="addPoint">
      <img :src="src" class="w-100" ref="image" />
      <div
        v-for="(point, index) in points"
        :key="index"
        class="annot-point-wrapper"
        :style="{ left: `${point.pos_x}%`, top: `${point.pos_y}%` }"
      >
        <div class="point" @click.stop="editPoint(index)"></div>
        <div class="product-card" v-if="!showToast && point.product" @click.stop="editPoint(index)">
          <img
            v-if="point.product.image"
            :src="mediaServer + '/' + point.product.image"
            class="product-thumb"
          />
          <div class="product-title">{{ point.product.serial }}</div>
        </div>
      </div>
      <ProductSelectorToast
        v-model:show="showToast"
        v-model="selectedPoint"
        v-on:change="save()"
        v-on:delete="remove()"
      />
    </div>
  </div>
</template>

<script>
import ProductSelectorToast from "./inputs/ProductSelectorToast.vue";
import tenant from "../modules/tenant";

export default {
  name: "ImageAnnotorious",
  components: { ProductSelectorToast },
  props: {
    id: String,
    src: String,
    rawPoints: Array,
  },
  emits: ["save", "update", "delete"],
  data() {
    return {
      points: [],
      selectedPoint: undefined,
      selectedIndex: -1,
      showToast: false,
    };
  },
  computed: {
    mediaServer() {
      return tenant.getAppMediaUrl();
    },
  },
  mounted() {
    for (const point of this.rawPoints) {
      this.points.push({
        id: point.id,
        pos_x: point.pos_x,
        pos_y: point.pos_y,
        product: {
          sku: point.sku,
          product_variant_id: point.product_variant_id,
          serial: point.serial,
          image: point.image,
        },
      });
    }
  },
  methods: {
    save() {
      if (this.selectedPoint.id) {
        this.$emit("update", this.selectedPoint);
      } else {
        this.$emit("save", this.selectedPoint);
      }
      this.points[this.selectedIndex] = this.selectedPoint;
      this.showToast = false;
    },
    remove() {
      if (this.selectedPoint.id) {
        this.$emit("delete", this.selectedPoint);
      }
      this.points.splice(this.selectedIndex, 1);
      this.showToast = false;
    },
    editPoint(index) {
      this.selectedIndex = index;
      this.selectedPoint = this.points[index];
      this.showToast = true;
    },
    addPoint(event) {
      if (this.showToast) {
        return;
      }

      const rect = this.$refs.image.getBoundingClientRect();
      const xPercent = ((event.clientX - rect.left) / rect.width) * 100;
      const yPercent = ((event.clientY - rect.top) / rect.height) * 100;

      this.points.push({ pos_x: xPercent, pos_y: yPercent });
      this.selectedIndex = this.points.length - 1;
      this.selectedPoint = this.points[this.selectedIndex];
      this.showToast = true;
    },
  },
};
</script>
<style scoped>
.image-container {
  position: relative;
  display: inline-block;
}

/* Point positioning wrapper */
.annot-point-wrapper {
  position: absolute;
  transition: 0.3s opacity;
  transform: translate(-50%, -50%);
  opacity: 0;
}

.image-container:hover .annot-point-wrapper,
.image-container:focus-within .annot-point-wrapper {
  opacity: 1;
}

.point {
  width: 12px;
  height: 12px;
  background-color: #8600f3;
  border-radius: 50%;
  border: 2px solid white;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
}

.point:hover {
  transform: scale(1.2);
  box-shadow: 0 0 12px rgba(134, 0, 243, 0.6);
}

.product-card {
  margin-top: 6px;
  min-width: 130px;
  background: rgba(255, 255, 255, 0.31);
  backdrop-filter: blur(10px) saturate(180%);
  -webkit-backdrop-filter: blur(10px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 10px;
  padding: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: opacity 0.2s ease;
}

/* Thumbnail */
.product-thumb {
  min-width: 34px;
  height: 34px;
  border-radius: 8px;
  object-fit: cover;
}

/* Product text */
.product-title {
  font-weight: 600;
  color: #000000;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}
</style>
